import React, { useContext, useEffect, useState } from 'react';
import KpiDefinitionData from 'service/KpiDefinitionData';
import { FilterContext } from 'components/FilterBar/FilterProvider';
import CardContainer from 'components/redesign/CardContainer';
import { KpiData } from 'components/redesign/KpiTile/types';
import KpiGrid from 'components/redesign/KpiGrid';
import KpiTile from 'components/redesign/KpiTile';
import totalUsers from 'v2/kpis/rgm/app/userAdoption/totalUsers';
import activeUsers from 'v2/kpis/rgm/app/userAdoption/activeUsers';
import adoptionRate from 'v2/kpis/rgm/app/userAdoption/adoptionRate';
import averageTimeInPlatform from 'v2/kpis/rgm/app/userAdoption/averageTimeInPlatform';
import uniquePageViews from 'v2/kpis/rgm/app/userAdoption/uniquePageViews';
import uniqueSessions from 'v2/kpis/rgm/app/userAdoption/uniqueUsers';
import newUsers from '@v2/kpis/rgm/app/userAdoption/newUsers';
import activeBU from '@v2/kpis/rgm/app/userAdoption/activeBU';
import { useDynamicGraphQLQuery } from '@hooks/useDynamicGraphQLQuery';

interface SummaryMetricsTPOUserAdoptionProps {
  title?: string;
  setOverviewConfig?: (config: string[]) => void;
  userBehaviorAndEngagementData?: {
    activeUsers: number;
    totalUsers: number;
    adoptionRate: number;
    averageTimeInPlatform: number;
  } | null;
}
const SummaryMetricsTPOUserAdoption: React.FC<
  SummaryMetricsTPOUserAdoptionProps
> = ({ title }) => {
  const [overViewConfig, setOverviewConfig] = useState<KpiData[]>([]);

  const { selectedProduct } = useContext(FilterContext);

  const { data, isLoading } = useDynamicGraphQLQuery(
    'getUserAdoptionScorecard',
    {},
    true,
    'StandardMetrics/UserAdoption'
  );

  useEffect(() => {
    if (data?.getUserAdoptionScorecard?.data && !isLoading) {
      // Restructure the data to match what handlers expect
      const handlerData = {
        getUserAdoptionScorecard: data.getUserAdoptionScorecard.data,
      };

      // Set the overview configuration with the existing handlers
      const updatedOverviewConfig = [
        totalUsers.handler(handlerData),
        activeUsers.handler(handlerData),
        newUsers.handler(handlerData),
        adoptionRate.handler(handlerData),
        averageTimeInPlatform.handler(handlerData),
        uniqueSessions.handler(handlerData, 'Unique Sessions'),
        uniquePageViews.handler(handlerData),
        activeBU.handler(handlerData),
      ];

      // Set the updated overview config
      setOverviewConfig(updatedOverviewConfig);
    } else {
      // Clear the overview config when there's no data
      setOverviewConfig([]);
    }
  }, [data, isLoading]);

  return (
    <CardContainer
      isLoading={isLoading}
      title={title}
      showInfoIcon={true}
      dataDefinitions={{
        sections:
          KpiDefinitionData[selectedProduct?.productId]
            ?.userBehaviorAndEngagement?.scoreCard ?? [],
      }}
      isAccordion={false}
    >
      <KpiGrid columnsDesktop={4} columnsTablet={2} columnsMobile={1}>
        {overViewConfig.map((item, index) => (
          <KpiTile key={index} data={item} />
        ))}
      </KpiGrid>
    </CardContainer>
  );
};

export default SummaryMetricsTPOUserAdoption;
